// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseAppConfig: {
    apiKey: "AIzaSyDE1NKusC8VSyQFBZPL27t-2_BUu5eUXy8",
    authDomain: "celikkanatlar-8.firebaseapp.com",
    projectId: "celikkanatlar-8",
    storageBucket: "celikkanatlar-8.firebasestorage.app",
    messagingSenderId: "902843049085",
    appId: "1:902843049085:web:fb9602c68b8b4a5b9f3d14",
    measurementId: "G-7N9VT0W4SH"
  },
  gpxz: {
    apiKey: 'ak_lq3yCGgw_V1XvR7YhzVLTde8b',
    apiUrl: 'https://api.gpxz.io/api/v1',
  },
  mgm: {
    radarUrl: "https://www.mgm.gov.tr/FTPDATA/uzal/radar"
  }
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
